import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowRightOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileArrowRightOut"><Path d="M21.4141 19L17 23.4141L15.5859 22L17.5859 20H12V18H17.5859L15.5859 16L17 14.5859L21.4141 19Z" fill="currentColor"/><Path d="M12 10H20V14.7578L17 11.7578L12.7578 16H10V22H4V2H12V10Z" fill="currentColor"/><Path d="M19.4141 8H14V2.58594L19.4141 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileArrowRightOut;
